const intialState = {
  activeCourseId: null,
  loading: false,
};

export default function downloadsReducer(state = intialState, action) {
  switch (action.type) {
    case "DOWNLOADS_COURSE_CHANGED":
      return {
        ...state,
        activeCourseId: action.activeCourseId,
        loading: true,
      };
    case "DOWNLOADS_COURSE_DATA_FETCHED":
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
